export interface IVillagePromotionsData {
  promotions: IPromotions[];
}
export interface IPromotions {
  /** Описание акции **/
  description?: string | null;
  /** Дата окончания акции **/
  endDate: string;
  /** ID акции **/
  id: number;
  /** Название акции **/
  name: string;
  /** Тип акции **/
  type: EType;
  /** ID КП **/
  villageId?: number;
  /** Подзаголовок **/
  subtitle?: string | null;
  /** Цвет заливки **/
  color?: string | null;
  /** Иконка акции **/
  promoLogoUrl?: string | null;
  /** Иконка акции для лейбла на выдаче **/
  labelPromoLogoUrl?: string | null;
}
export enum EType {
  /** Бонус **/
  Bonus = 'bonus',
  /** Материнский капитал **/
  MaternalCapital = 'maternalCapital',
  /** Военная ипотека **/
  MilitaryMortgage = 'militaryMortgage',
  /** Ипотека **/
  Mortgage = 'mortgage',
  /** Скидка **/
  Sale = 'sale',
}
